import React, { useState, useEffect } from "react";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import Illustration from "../../../../../partials/content/Illustration";
import { getCustomerSalesOrders } from "../../../../../services/sales/customerService";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { Badge } from "react-bootstrap";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import { DialogActions } from "@material-ui/core";
import NumberFormat from "react-number-format";
import { formatDate } from "../../../../../utils/utils";
import { Card } from "primereact/card";
import CustomPrintOutSalesOrder from "../../../../../partials/content/CustomPrintOutSalesOrder";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
const CustomerSalesOrders = ({ history, customerID }) => {
  const { reload } = useGlobalData();
  const [auth, setAuth] = useState({});
  const [customerSalesOrders, setCustomerSalesOrders] = useState([]);
  const [customerSalesOrder, setCustomerSalesOrder] = useState({});
  const [openSalesOrderPrint, setOpenSalesOrderPrint] = useState(false);
  const [fullybilleds, setFullyBilleds] = useState(0);
  const [partiallyBilleds, setPartiallyBilleds] = useState(0);
  const [unbilleds, setUnbilleds] = useState(0);

  useEffect(() => {
    getCustomerSalesOrdersData();
  }, [customerID, reload]);

  async function getCustomerSalesOrdersData() {
    const response = await getCustomerSalesOrders(customerID);
    const { data, auth } = response.data;
    setCustomerSalesOrders(data.salesOrders);
    setAuth(auth);
    const fullybilleds = data.salesOrders.filter(
      (salesOrder) => salesOrder.invoiceStatus === 3
    );
    const partiallyBilleds = data.salesOrders.filter(
      (salesOrder) => salesOrder.invoiceStatus === 2
    );
    const unbilleds = data.salesOrders.filter(
      (salesOrder) => salesOrder.invoiceStatus === 1
    );
    setFullyBilleds(fullybilleds.length);
    setPartiallyBilleds(partiallyBilleds.length);
    setUnbilleds(unbilleds.length);
  }

  const customerSalesOrdersDetailColumn = [
    {
      header: "Expected Delivery Date",
      field: "expDeliveryDate",
      type: "date",
    },
    {
      header: "Quotation ID",
      field: "quotationCode",
      type: "string",
    },
    {
      header: "Sales Agent",
      field: "salesName",
      type: "string",
    },
    {
      header: "Customer PO Number",
      field: "customerPoNo",
      type: "string",
    },
    {
      header: "Exchange Rate To Base Currency",
      field: "exchangeRate",
      type: "currency",
    },
    {
      header: "Approval Status",
      field: "approvalStatusDesc",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col-sm-4 col-md-4 col-lg-4">
          <Card id="overviewcard" className="border-success">
            <div className="kt-widget4">
              <div className="kt-widget4__item ">
                <span className="kt-widget4__icon">
                  <i className="fas fa-check-circle kt-font-success" />
                </span>
                <div className="kt-widget4__info ">
                  <div className="kt-widget4__highlighttitle">FULLY BILLED</div>
                </div>
                <Badge variant="success">{fullybilleds}</Badge>
              </div>
            </div>
          </Card>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <Card id="overviewcard" className="border-warning">
            <div className="kt-widget4">
              <div className="kt-widget4__item ">
                <span className="kt-widget4__icon">
                  <i className="fas fa-exclamation-circle kt-font-warning" />
                </span>
                <div className="kt-widget4__info ">
                  <div className="kt-widget4__highlighttitle">
                    PARTIALLY BILLED
                  </div>
                </div>
                <Badge variant="warning">{partiallyBilleds}</Badge>
              </div>
            </div>
          </Card>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <Card id="overviewcard" className="border-danger">
            <div className="kt-widget4">
              <div className="kt-widget4__item ">
                <span className="kt-widget4__icon">
                  <i className="fas fa-times-circle kt-font-danger" />
                </span>
                <div className="kt-widget4__info ">
                  <div className="kt-widget4__highlighttitle">UNBILLED</div>
                </div>
                <Badge variant="danger">{unbilleds}</Badge>
              </div>
            </div>
          </Card>
        </div>
      </div>
      {customerSalesOrders.length ? (
        <React.Fragment>
          <CustomDataTable
            data={customerSalesOrders}
            dataDetailColumns={customerSalesOrdersDetailColumn}
            onRefreshData={() => {
              getCustomerSalesOrdersData(customerID);
            }}
            columns={[
              {
                header: "Sales Order ID",
                field: "salesOrderCode",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Order Date",
                field: "orderDate",
                body: (rowData) => formatDate(rowData.orderDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Goods Issue Status",
                field: "giStatusDesc",
                body: (rowData) => {
                  if (rowData.giStatus === 1) {
                    return (
                      <Badge variant="danger">{rowData.giStatusDesc}</Badge>
                    );
                  } else if (rowData.giStatus === 2) {
                    return (
                      <Badge variant="warning">{rowData.giStatusDesc}</Badge>
                    );
                  } else if (rowData.giStatus === 3) {
                    return (
                      <Badge variant="success">{rowData.giStatusDesc}</Badge>
                    );
                  } else {
                    return <Badge variant="dark">{rowData.giStatusDesc}</Badge>;
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Invoice Status",
                field: "invoiceStatusDesc",
                body: (rowData) => {
                  if (rowData.invoiceStatus === 1) {
                    return (
                      <Badge variant="danger">
                        {rowData.invoiceStatusDesc}
                      </Badge>
                    );
                  } else if (rowData.invoiceStatus === 2) {
                    return (
                      <Badge variant="warning">
                        {rowData.invoiceStatusDesc}
                      </Badge>
                    );
                  } else if (rowData.invoiceStatus === 3) {
                    return (
                      <Badge variant="success">
                        {rowData.invoiceStatusDesc}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge variant="dark">{rowData.invoiceStatusDesc}</Badge>
                    );
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currency.currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Grand Total",
                field: "grandTotal",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.grandTotal}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.view ? (
                      <React.Fragment>
                        <BootstrapTooltip title="Sales Order Detail">
                          <button
                            type="button"
                            onClick={() => {
                              history.push(
                                "/sales/sales-order/sales-order-detail/" +
                                  rowData.ID
                              );
                            }}
                            className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-list-alt"></i>
                          </button>
                        </BootstrapTooltip>
                        <BootstrapTooltip title="Sales Order PrintOut">
                          <button
                            type="button"
                            onClick={() => {
                              setCustomerSalesOrder(rowData);
                              setOpenSalesOrderPrint(true);
                            }}
                            className="btn btn-icon btn-label-info btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-print"></i>
                          </button>
                        </BootstrapTooltip>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Sales.png"
            guidance="You don't have any Sales Orders for this customer yet"
            guidanceLeftIcon="fas fa-info-circle kt-font-warning"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
              onClick={() => {
                history.push("/sales/sales-order/sales-order-list");
              }}
            >
              <i className="fas fa-map-marker-alt"></i>
              Go To Sales Order
            </button>
          </div>
        </React.Fragment>
      )}
      <DialogLayout
        open={openSalesOrderPrint}
        title="Sales Order PrintOut"
        onCloseDialog={() => {
          setOpenSalesOrderPrint(false);
        }}
        maxWIdth="lg"
      >
        <CustomPrintOutSalesOrder salesOrderID={customerSalesOrder.ID} />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSalesOrderPrint(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
};

export default CustomerSalesOrders;
